<template>
  <div @click.stop
       v-show="visible">
    <div class="question-wang-editor"
         :style="style">
      <wang-editor-v2
        v-model="html"></wang-editor-v2>
    </div>
  </div>
</template>

<script>
import WangEditorV2 from '@components/WangEditorV2Deprecated'

export default {
  components: {WangEditorV2},
  props: {},
  data () {
    return {
      visible: false,
      content: '',
      style: {},
      txtHeight: '',
      disabled: false,
    }
  },
  computed: {
    html: {
      get () {
        return this.content
      },
      set (html) {
        this.content = html
        this.callback({html}, this)
      },
    },
  },
  watch: {},
  created () {
    document.addEventListener('click', this.hide)
  },
  mounted () {},
  destroyed () {
    document.removeEventListener('click', this.hide)
  },
  methods: {
    hide () {
      this.visible = false
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
.question-wang-editor {
  position: absolute;
  background-color: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 500px;
  height: auto;

  .wangEditor-container {
    border: none;
  }

  .wangEditor-txt {
    height: auto !important;
    min-height: 115px;
  }

  &:hover {
    border-color: #c0c4cc;
  }

  /*.ql-container {*/
  /*font-size: inherit;*/
  /*}*/

  /*.ql-container.ql-snow {*/
  /*background-color: white;*/
  /*box-sizing: border-box;*/
  /*border: none;*/
  /*width: 100%;*/
  /*}*/

  /*.ql-toolbar.ql-snow {*/
  /*background-color: white;*/
  /*padding: 5px 15px;*/
  /*box-sizing: border-box;*/
  /*width: 100%;*/
  /*border: none;*/
  /*border-bottom: 1px solid #dcdfe6;*/
  /*}*/
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/question-wang-editor/src/main.vue